import { render, staticRenderFns } from "./MessageCustomerMenu.vue?vue&type=template&id=319b063b&scoped=true&"
import script from "./MessageCustomerMenu.vue?vue&type=script&lang=js&"
export * from "./MessageCustomerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b063b",
  null
  
)

export default component.exports